import Vue from "vue";
import "./plugins/axios";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./quasar";
import i18n from "./i18n";
import "@/scss/custom.scss";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import VueGtag from "vue-gtag";
// Vue.use(VueGtag, {
//   config: { id: "G-7B1XMCTZ0F" }
// }, router);
Vue.use(
  VueGtag,
  {
    config: { id: "G-HPKV0DY2Y7" },
    pageTrackerTemplate(to) {
      let title = to.name;
      if (title == "Home") {
        title = "Home - Tarjeta Pircana";
      }
      if (title == "login") {
        title = "Login - Tarjeta Pircana";
      }
      if (title == "signup") {
        title = "Registrar - Tarjeta Pircana";
      }
      if (title == "recuperar") {
        title = "Recuperar Contraseña - Tarjeta Pircana";
      }
      if (title == "Contacto") {
        title = "Contacto - Tarjeta Pircana";
      }
      if (title == "Requisitos") {
        title = "Requisitos - Tarjeta Pircana";
      }
      if (title == "Categorias") {
        title = "Categorías - Tarjeta Pircana";
      }
      if (title == "Comercios") {
        title = "Comercios - Tarjeta Pircana";
      }
      if (title == "Beneficio") {
        title = "Beneficio - Tarjeta Pircana";
      }
      if (title == "Terminos") {
        title = "Terminos y Condiciones - Tarjeta Pircana";
      }
      if (title == "ApplicationsList") {
        title = "Solicitudes - Tarjeta Pircana";
      }
      if (title == "Applications") {
        title = "Validar Rut - Tarjeta Pircana";
      }
      if (title == "ApplicationEdit") {
        title = "Solicitud - Tarjeta Pircana";
      }
      if (title == "ApplicationDetails") {
        title = "Solicitud - Tarjeta Pircana";
      }
      if (title == "solicitud") {
        title = "Solicitud - Tarjeta Pircana";
      }
      if (title == "perfil") {
        title = "Perfil - Tarjeta Pircana";
      }
      if (title == "editar") {
        title = "Editar - Tarjeta Pircana";
      }
      if (title == "configuracion") {
        title = "Mis Datos - Tarjeta Pircana";
      }
      if (to.params.nombre) {
        if (title == "Tarjeta Pircana") {
          title = to.params.nombre.replaceAll("-", " ") + " - " + title;
        } else {
          title = title + " - " + to.params.nombre.replaceAll("-", " ");
        }
      }
      return {
        page_title: title,
        page_path: to.path
      };
    }
  },
  router
);

const isProd = process.env.NODE_ENV === "production";

Vue.use(VueSweetalert2);

//Truncate text
var filter = function(text, length, clamp) {
  clamp = clamp || "...";
  var node = document.createElement("div");
  node.innerHTML = text;
  var content = node.textContent;
  if (content) {
    return content.length > length ? content.slice(0, length) + clamp : content;
  } else {
    return text;
  }
};
Vue.filter("truncate", filter);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
